
























































































import { Component, Vue, Prop } from "vue-property-decorator";
import CardInputResep from "@/components/pemeriksaan/CardInputResep.vue";
import CardListResep from "./resep-obat/CardListResep.vue";
import { resepStore } from "@/store/modules/resep";
import { appModule } from "@/store/modules/app";
import http from "@/axios/http-common";
import { userModule } from "@/store/modules/user";
import PaketObatList from "./resep-obat/lembar-permintaan/PaketObat/PaketObatList.vue";
import AntimikrobaReserveList from "./resep-obat/lembar-permintaan/AntimikrobaReserve/AntimikrobaReserveList.vue";

@Component({
  components: {
    CardInputResep,
    CardListResep,
    PaketObatList,
    AntimikrobaReserveList,
  },
  inject: {
    isReadOnly: { default: () => () => false },
  },
})
export default class TabResepObat extends Vue {
  dataExample = "";
  listResep = [];
  activeResep = {};
  timeout = 2000;
  innerTab = "sub-resep-bmhp";

  @Prop() register: number;

  @Prop() rm: number;

  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  mounted() {
    this.getResepList(this.register).then(() => {
      const userResep = resepStore.resep.filter((resep) => {
        return resep.dokter.id == userModule.user.id;
      });

      if (userResep.length) {
        this.setActiveResep(userResep[userResep.length - 1]);
      }
    });
  }

  get stateuser() {
    return userModule.user;
  }

  get loading() {
    return appModule.loading;
  }

  get mode() {
    return appModule.mode;
  }

  get snackbar() {
    return appModule.snackbar;
  }

  get notice() {
    return appModule.notice;
  }

  updateResepList() {
    this.getResepList(this.register);
  }

  setActiveResep(val) {
    this.activeResep = val;
  }

  getResepList(reg) {
    resepStore.SET_LIST_LOADING(true);

    return http
      .getData(`/register/${reg}/resep-obat-text`)
      .then((response) => {
        resepStore.setResep(response.data.data);
        // console.log("aaa:", response.data.data);
      })
      .then(() => {
        resepStore.SET_LIST_LOADING(false);
      });
  }

  addResep() {
    this.activeResep = {};
    resepStore.showInputResep();
  }
}
